import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`WFP’s data shows that the refugees mostly spent it on rent, utilities, food and other household supplies. The assistance gave families some financial stability so they could start rebuilding their lives after the trauma of war. Surveys taken by WFP revealed that families’ lives improved a lot after they started receiving the monthly cash transfers. `}</p>
    <p>{`The ESSN is the biggest humanitarian project that the EU has ever funded, with WFP receiving €350 million in 2019 and a total of €1.4 billion since the start of the programme in 2016. It is also one of the largest humanitarian cash programmes ever mounted by the United Nations.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      